import { defer } from "react-router";
const cdn = `https://dcs0nmbtl4cfs.cloudfront.net`;
const s3url = `https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com`;
const programmes = [
  {                          //73 excel sheet SN
    date:"23-02-2026 ",
    startDate:"23.02.2026",
    endDate:"",
    title:"IPR Basics for Innovators and Entrepreneurs (ECE) "  ,
    type:"",
    coordinator:"Dr.G.KarpagaRajesh (ASP) ECE",
    venue:"Seminar Hall ECE Dept",
    photos:[
      `${cdn}/iqac/IPR2.webp`,
      `${cdn}/iqac/IPR3.webp`,
      `${cdn}/iqac/IPR1.webp`,
      

    ],
    pdf:""

 	

  },
  {                          //73 excel sheet SN
    date:"21-02-2026 ",
    startDate:"21.02.2026",
    endDate:"",
    title:"THIRAN   DEMO DAY - 2025 "  ,
    type:"",
    coordinator:"ACCETOSA",
    venue:"Sangamam Hall",
    photos:[
      `${cdn}/iqac/thiran1st+year+demo+2.webp`,
      `${cdn}/iqac/thiran1st+year+demo+1.webp`,
      `${cdn}/iqac/thiran1st+year+demo+3.webp`,
      

    ],
    pdf:""

 	

  },
    {                          //73 excel sheet SN
    date:"20-02-2026 ",
    startDate:"20.02.2026",
    endDate:"",
    title:"Workshop on Nimirndhu Nil Hackathon -EDII -TN Program  "  ,
    type:"",
    coordinator:"Dr.D.Helena Margaret ASP ECE DEPT",
    venue:"sangamam hall",
    photos:[
      `${cdn}/iqac/workshop1.webp`,
      `${cdn}/iqac/workshop2.webp`,
      `${cdn}/iqac/workshop3.webp`,
      

    ],
    pdf:""

 	

  },
    {                          //73 excel sheet SN
    date:"16-02-2026 ",
    startDate:"16.02.2026",
    endDate:"",
    title:"AI &.4.0 Tools for  Innovators, Entrepreneurs Workshop (CSE Dept"  ,
    type:"",
    coordinator:"Dr.C.Uma Rani HOD (CSE Dept)",
    venue:"Virtual Hall CSE dept",
    photos:[
      `${cdn}/iqac/Aiworkshop3.webp`,
      `${cdn}/iqac/Aiworkshop2.webp`,
      `${cdn}/iqac/Aiworkshop4.webp`,
      

    ],
    pdf:""

 	

  },
  {                          //77 excel sheet SN
    date:"13.02.2026 ",
    startDate:"13.02.2026",
    endDate:"",
    title:" Free Laptop Distribution Ceremony for Students  (3rd year) ",
    type:"",
    coordinator:"ACGCET",
    venue:"Sangamam Hall",
    photos:[
      `${cdn}/iqac/Free+Laptop(3rd+year)4.webp`,
      `${cdn}/iqac/Free+Laptop(3rd+year)3.webp`,
      `${cdn}/iqac/Free+Laptop(3rd+year)2.webp`,
      `${cdn}/iqac/Free+Laptop(3rd+year)1.webp`,

    ],
    pdf:""
  },
{                      //76              
    date:"06.02.2026 ",
    startDate:"06.02.2026",
    endDate:"",
    title:"Tamil Nadu State Council for Higher Education (TANSCHE) Workshop",
    type:"",
    coordinator:"ACGCET",
    venue:"Sangamam Hall",
    photos:[
      `${cdn}/iqac/tanshe2.webp`,
      `${cdn}/iqac/tanshe1.webp`,
      `${cdn}/iqac/tanshe3.webp`,
      

    ],
    pdf:"https://drive.google.com/file/d/1sXh_qSVRmzzOdFJTTmlIY5bz6ClnFn8E/view?usp=drivesdk"

 	

  },
  {                          //73 excel sheet SN
    date:"06-02-2026 ",
    startDate:"06.02.2026",
    endDate:"",
    title:"பாணன் பொழிவு (முத்தமிழ் மன்றம்)  ",
    type:"",
    coordinator:"Mrs.Rajamani (ASP )English Dept",
    venue:"Murugappa hall",
    photos:[
      `${cdn}/iqac/Pannanpolivu2.webp`,
      `${cdn}/iqac/Pannanpolivu1.webp`,
      `${cdn}/iqac/Pannanpolivu3.webp`,
      

    ],
    pdf:"https://drive.google.com/file/d/1sSYVgI2Pxz1eqs_aqs7CtCHP7JL-9BDl/view?usp=drivesdk"

 	

  },
   {                          //73 excel sheet SN
    date:"05-02-2026 ",
    startDate:"05.02.2026",
    endDate:"",
    title:"3D(Decide,Drive,Defend) Road Safety Awareness Program (NSS)",
    type:"",
    coordinator:"Dr.R.Sarala Associate Professor (Mech)",
    venue:"Murugappa hall",
    photos:[
      `${cdn}/iqac/3d1_11zon.webp`,
      `${cdn}/iqac/3d2_11zon.webp`,
      `${cdn}/iqac/3d3_11zon.webp`,
      `${cdn}/iqac/3d4_11zon.webp`,

    ],
    pdf:"https://drive.google.com/file/d/1sQZOCQ1VHA0MTdsYVzNTgZUFnPAVq9zL/view?usp=drivesdk"

 	

  },
   {                          //73 excel sheet SN
    date:"04-02-2026 ",
    startDate:"04.02.2026",
    endDate:"",
    title:"Career Guidance -Study Abroad Opportunities Seminar",
    type:"",
    coordinator:"Dr. X. Hyacinth Suganthi, Placement Coordinator",
    venue:"Sangamam Hall ",
    photos:[
      `${cdn}/iqac/Career+Guidance_2.webp`,
      `${cdn}/iqac/Career+Guidance_1.webp`,
      `${cdn}/iqac/Career+Guidance_4.webp`,
      `${cdn}/iqac/Career+Guidance_3.webp`,

    ],
    pdf:"https://drive.google.com/file/d/12cYqj5LBvTHLfOrx6ylsjZLuMiB7x606/view?usp=sharing"
  },

   {                        //72
    date:"03-02-2026 ",
    startDate:"03.02.2026",
    endDate:"",
    title:"The Power of Time Management - Motivation session",
    type:"",
    coordinator:"Miss.P.Sezhina Kanakambika (ASP) ECE Dept",
    venue:"COE Lab -ECE Dept ",
    photos:[
            `${cdn}/iqac/Motivation+session_1.webp`,
            `${cdn}/iqac/Motivation+session_3.webp`,
            `${cdn}/iqac/Motivation+session_2.webp`,
            `${cdn}/iqac/Motivation+session_4.webp`,
    ],
    pdf:"https://drive.google.com/file/d/1XW3klmAVzwW7uvkF6v64WUUeTFnyhFTL/view?usp=sharing"

 	

  },
  //  {                         //71
  //   date:" 26-01-2026",
  //   startDate:"26.01.2026",
  //   endDate:"",
  //   title:"Republic Day celebration -2026",
  //   type:"",
  //   coordinator:"ACGCET",
  //   venue:"ACGCET Main building ",
  //   photos:[
  //     ``
  //     ``
  //     ``
  //     ``
  //   ],
  //   pdf:""

 	

  // },
   {                      //70
    date:"23-01-2026 ",
    startDate:"23.01.2026",
    endDate:"",
    title:"NBA Visit - ECE Dept",
    type:"",
    coordinator:"ACGCET",
    venue:" ECE Department ",
    photos:[
      `${cdn}/iqac/ECE+NBA-1.webp`,
      `${cdn}/iqac/ECE+NBA-3.webp`,
      `${cdn}/iqac/ECE+NBA-4.webp`,
      `${cdn}/iqac/ECE-NBA-2+.webp`,
    
    ],
    pdf:""

 	

  },
   {                      //69
    date:"12-01-2026 ",
    startDate:"12.01.2026",
    endDate:"",
    title:"Naan Mudhalvan Tamil Nadu State Level Placement Program(TNSK)",
    type:"",
    coordinator:"ACGCET",
    venue:" Sangamam Hall ",
    photos:[
      `${cdn}/iqac/Naan+mudhalvan-TNSK_3.webp`,
      `${cdn}/iqac/Naan+mudhalvan-TNSK_2.webp`,
      `${cdn}/iqac/Naan+mudhalvan-TNSK_1.webp`,
      `${cdn}/iqac/Naan+mudhalvan-TNSK_1.webp`,
      
    ],
    pdf:"https://drive.google.com/file/d/1F6WgHtbMQI_4OKZwSjply4Rf8hl1kGIr/view?usp=sharing"

 	

  },
   {                        //68
    date:"12-01-2026 ",
    startDate:"12.01.2026",
    endDate:"",
    title:"Pongal Celebration -2026",
    type:"",
    coordinator:"ACGCET",
    venue:"ACGCET Play Ground ",
    photos:[
      `${cdn}/iqac/Pongal-1.webp`,
      `${cdn}/iqac/pongal-2.webp`,
      `${cdn}/iqac/pongal-3.webp`,
      `${cdn}/iqac/pongal-4.webp`
    ],
    pdf:""

 	

  },
   {                        //67
    date:" 07-01-2026",
    startDate:"07.01.2026",
    endDate:"",
    title:" Free Laptop Distribution Ceremony For Students (உலகம் உங்கள் கையில்)",
    type:"",
    coordinator:"ACGCET",
    venue:"Seminar Hall Cse dept ",
    photos:[
      `${cdn}/iqac/Laptop-0.webp`,
      `${cdn}/iqac/Laptop-1.webp`,
      `${cdn}/iqac/Laptop-2.webp`,
      `${cdn}/iqac/Laptop-3.webp`,
    
    ],pdf:""

 	

  },
  
   {                         //66
    date:" 05-01-2026",
    startDate:"05.01.2026",
    endDate:"",
    title:"உலகம் உங்கள் கையில்",
    type:"",
    coordinator:"TN Program",
    venue:"Seminar Hall ECE dept ",
    photos:[      
                `${cdn}/iqac/ulagam-66-1.webp`,
                `${cdn}/iqac/Ulagam-66-3.webp`,
                `${cdn}/iqac/Ulagam-66-4.webp`,
                `${cdn}/iqac/Ulagam-66-2.webp`,
      
    ],
    pdf:""

 	

  },
   {                           //65
    date:"02-01-2026",
    startDate:" 02.01.2026",
    endDate:"",
    title:"Alignment of the Assessment and Course Outcomes (COS) with programme outcomes (POS) as mandated by AICTE",
    type:"",
    coordinator:"ACGCET",
    venue:" Principal Office Conference Hall",
    photos:[  
             `${cdn}/iqac/Alignment-5.webp`,
             `${cdn}/iqac/Alignment-4.webp`,
             `${cdn}/iqac/Alignment-3.webp`,
             `${cdn}/iqac/Alignment-1.webp`,
      
    ],
    pdf:"https://drive.google.com/file/d/1qw1p-Ks198tX6A8I12M9DUsXLqpU8dhY/view?usp=sharing"

 	

  },

  {                        //64
    date:" 29-12-2025",
    startDate:"29.12.2025",
    endDate:"04.01.2026",
    title:"Naan Mudhalvan (FDP)",
    type:"",
    coordinator:"TN Program",
    venue:"sangamam hall ",
    photos:[
      `${cdn}/iqac/Naan+mudhalvan-4.webp`,
      `${cdn}/iqac/Naan+mudhalvan-2.webp`,
      `${cdn}/iqac/Naan+mudhalvan-3.webp`,
      `${cdn}/iqac/Naan+mudhalvan-1.webp`,
      
    ],
    pdf:""

 	

  },

  {
    date: "2025-12-23",
    startDate: "23.12.2025",
    endDate: "",
    title: "TANSCHE Workshop on FRAMING ANALYTICAL QUESTIONS",
    type: "",
    coordinator: "ACGCET",
    venue: "Sangamam hall",
    photos: [
      `${cdn}/iqac/TANSCHE1.webp`,
      `${cdn}/iqac/TANSCHE2.webp`,
      `${cdn}/iqac/TANSCHE3.webp`,
      `${cdn}/iqac/TANSCHE4.webp`
    ],
    pdf: "https://drive.google.com/file/d/1t1nxezwewPKub-RfevpXtL9GFod1YBMO/view",

  },
  // {
  //   startDate:"23.12.2025",
  //   endDate:"",
  //   title:"Tamil Nadu State Council for Higher Education (TANSCHE) Workshop on FRAMING ANALYTICAL QUESTIONS",
  //   type:"",
  //   coordinator:"ACGCET",
  //   venue :"Sangamam Hall",
  //   photos:[
  //     "${cdn}/iqac/FRAME_ANALYTICAL_QUESTION_4.webp",
  //     "${cdn}/iqac/FRAME_ANALYTICAL_QUESTION_3.webp",
  //     "${cdn}/iqac/FRAME_ANALYTICAL_QUESTION.webp",
  //     "${cdn}/iqac/FRAME_ANALYTICAL_QUESTION_1.webp"
  //   ],
  //   pdf:"https://drive.google.com/file/d/1K0E_ckzvt8iLMPli5gRFM0OtVc8pYb1Y/view?usp=drivesdk",

  // },
  {
    date: "2025-12-11",
    startDate: "11.12.2025",
    endDate: "",
    title: "Golden Jubilee celebrations 1975-1980 batch",
    type: "",
    coordinator: "ACCETOSA",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/goldernjublee_3.webp`,
      `${cdn}/iqac/goldernjublee_2.webp`,
      `${cdn}/iqac/goldernjublee_1.webp`,
      `${cdn}/iqac/goldernjublee_4.webp`,
    ],
    pdf: "https://drive.google.com/file/d/1XVGItmnfgKgL9CEP_tQHzLLYIQzRJLls/view?usp=sharing",

  },

  {
    date: "2025-11-11",
    startDate: "11.11.2025",
    endDate: "",
    title: "Diamond Jubilee Reunion Celebration 1960-1965 batch ",
    type: "",
    coordinator: "ACCETOSA",
    venue: " ACCETOSA AICTE Idea Lab",
    photos: [
      `${cdn}/iqac/goldernjublee1.webp`,
      `${cdn}/iqac/goldernjublee2.webp`,
      `${cdn}/iqac/goldernjublee3.webp`,
      `${cdn}/iqac/goldernjublee4.webp`,
    ],
    pdf: "",


  },
  {
    date: "2025-10-31",
    startDate: "31.10.2025",
    endDate: "",
    title: "INNOVERISE-25 IllUminate -wokshop E-Cell IITBombay & EDC ACGCET ",
    type: "",
    coordinator: "Dr.D.Helena Margaret (AP) ECE DEPT",
    venue: "Virtual Hall EEE Dept",
    photos: [
      `${cdn}/iqac/illumiinate1.webp`,
      `${cdn}/iqac/illuminate2.webp`,
      `${cdn}/iqac/illuminate3.webp`,
      `${cdn}/iqac/illuminate4.webp`,
    ],
    pdf: "",

  },
  {
    date: "2025-10-31",
    startDate: "31.10.2025",
    endDate: "",
    title: "Blood Donation Camp-2025 ",
    type: "",
    coordinator: "Mr. Pradeep (AP) EEE Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/blooddt1.webp`,
      `${cdn}/iqac/blooddt2.webp`,
      `${cdn}/iqac/blooddt3.webp`,
      `${cdn}/iqac/blooddt4.webp`,
    ],
    pdf: "",
  },

  {
    date: "2025-10-31",
    startDate: "31.10.2025",
    endDate: "",
    title: "CENCON-25 (Inter Collegiate Technical Symposium civil )  ",
    type: "",
    coordinator: "Dr.R. Prakash (AP) CIVIL Dept",
    venue: "Sangamam hall",
    photos: [
      `${cdn}/iqac/civilsympo0.webp`,
      `${cdn}/iqac/civilsympo1.webp`,
      `${cdn}/iqac/civilsympo2.webp`,
      `${cdn}/iqac/civilsympo3.webp`,
    ],
    pdf: "",
  },
  {
    date: "2025-10-30",
    startDate: "29.10 2025 ",
    endDate: "30.10.2025",
    title: "Alconesy-25 -Inter Collegiate Technical Symposium EEE Dept A",
    type: "",
    coordinator: "Dr.A.Arunya Revathi  (Assistant HOD ) EEE",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/eee+sympo1.webp`,
      `${cdn}/iqac/eee+sympo4.webp`,
      `${cdn}/iqac/eee+sympo+2.webp`,
      `${cdn}/iqac/eee+sympo+3.webp`,
    ],
    pdf: "",

  },
  {
    date: "2025-10-28",
    startDate: "28.10 .2025 ",
    endDate: "",
    title: "Fresher's Association-2025",
    type: "",
    coordinator: "Dr.S.R.Cynthia (AP) Physics Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/fresherrs4.webp`,
      `${cdn}/iqac/freshers1.webp`,
      `${cdn}/iqac/freshers2.webp`,
      `${cdn}/iqac/freshers3.webp`,

    ],
    pdf: "https://drive.google.com/file/d/1bGJYlly8DLCxstfBWusbv6_ntMkBSktu/view?usp=sharing",
  },
  {
    date: "2025-10-27",
    startDate: "27.10.2025",
    endDate: "",
    title: "INNOVERSE-25(ISTE Stuents Chapter (TN 156)) ",
    type: "",
    coordinator: "Dr.Uma Rani HOD CSE Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/dr+umarani+hod+of+cse+iste4.webp`,
      `${cdn}/iqac/iste1.webp`,
      `${cdn}/iqac/iste2.webp`,
      `${cdn}/iqac/iste3.webp`,
    ]

  },
  {
    date: "2025-10-24",
    startDate: "24.10.2025",
    endDate: "",
    title: " Shackels-25 INTER Collegiate Syposium - Mechanical  ",
    type: "",
    coordinator: "Mr.V.Jawahar (AP) MECH Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/mechsympo1.webp`,
      `${cdn}/iqac/mechsympo2.webp`,
      `${cdn}/iqac/mechsympo3.webp`,
      `${cdn}/iqac/mechsympo4.webp`,
    ],
    pdf: "",
  },
  {
    date: "2025-10-23",
    startDate: "23.10 2025",
    endDate: "",
    title: " Zhagaram  Inauguration",
    type: "",
    coordinator: "Dr.Bala Sundar (AP) Maths  Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Dr.A%2CSivanantharaja+HOD+ECE.webp`,
      `${cdn}/iqac/11.webp`,
      `${cdn}/iqac/Group+Dance+-2.webp`,
      `${cdn}/iqac/4.webp`,
    ],
    pdf: "",
  },

  {
    date: "2025-10-23",
    startDate: "23.10.2025",
    endDate: "",
    title: "கல்லூரி கலைத் திருவிழா",
    type: "",
    coordinator: "Dr.K.T.Loganathan HOD Chemistry Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/compressed+(2)/tamilclub1.webp`,
      `${cdn}/iqac/compressed+(2)/tamilclub2.webp`,
      `${cdn}/iqac/compressed+(2)/tamilclub3.webp`,
      `${cdn}/iqac/tamilclub4.webp`,


    ],
    pdf: "",
  },
  {
    date: "2025-10-15",
    startDate: "15.10.2025",
    endDate: "16.10.2025",
    title: "SYGNEL'S-25 Inter College Smposium (ECE Dept) ",
    type: "",
    coordinator: "Mrs.M.AruniRani (AP) ECE Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/ece+sympo1.webp`,
      `${cdn}/iqac/ece+sympo2.webp`,
      `${cdn}/iqac/ece+symp3.webp`,
      `${cdn}/iqac/ece+sympo4.webp`,
    ],
    pdf: "https://drive.google.com/file/d/1GfD4ONmpcnnuuEVHP_RP7G_GGo-BP4Hv/view?usp=sharing",

  },
  {
    date: "2025-10-14",
    startDate: "14.10.2025",
    endDate: "",
    title: "அகழ்-25 (முத்தமிழ் மன்றம் ) ",
    type: "",
    coordinator: "Miss.A.Rajamani (ASP) English Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Agal25'.webp`,
      `${cdn}/iqac/Agal25'''.webp`,
      `${cdn}/iqac/Agal25''.webp`,
      `${cdn}/iqac/Agal25.webp`
    ],
    pdf: "",
  },

  {
    date: "2025-10-13",
    startDate: "13.10.2025",
    endDate: "",
    title: "Anna University Zonal-XVI  Kho-Kho & Chess Tournaments",
    type: "",
    coordinator: "Dr.M.Adhimoolam Physical Director",
    venue: "ACGCET Kho-Kho Court & Drawing hall",
    photos: [
      `${cdn}/iqac/kho-kho25'''.webp`,
      `${cdn}/iqac/kho-kho25''.webp`,
      `${cdn}/iqac/kho-kho25'.webp`,
      `${cdn}/iqac/kho-kho25.webp`

    ],
    pdf: "",
  },

  {
    date: "2025-10-13",
    startDate: "13.10.2025",
    endDate: "",
    title: "Rotarise-25 (Rotaract Club)",
    type: "",
    coordinator: "Mr.V.Pradeep (ASP) EEE Dept ",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Rotarise.webp`,
      `${cdn}/iqac/Rotarise1.webp`,
      `${cdn}/iqac/Rotarise2.webp`,
      `${cdn}/iqac/Rotarise3.webp`

    ],
    pdf: "",
  },

  {
    date: "2025-10-13",
    startDate: "13.10.2025",
    endDate: "",
    title: "Cognoblaze-25(CSE Symposium)",
    type: "",
    coordinator: "Mrs.K.Chandraprabha (ASP) Dept CSE",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/cognoblaze25'''.webp`,
      `${cdn}/iqac/cognoblaze25''.webp`,
      `${cdn}/iqac/cognoblaze25'.webp`,
      `${cdn}/iqac/cognoblaze25.webp`

    ],
    pdf: "",
  },

  {
    date: "2025-10-11",
    startDate: "11.10.2025",
    endDate: "",
    title: "DEMO DAY-25 ACCETOSA",
    type: "",
    coordinator: "ACCETOSA",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/Demo+Day4.webp`,
      `${cdn}/iqac/Demo+Day3.webp`,
      `${cdn}/iqac/Demo+Day2.webp`,
      `${cdn}/iqac/Demo+Day1.webp`,
      `${cdn}/iqac/Demo+Day.webp`
    ],
    pdf: "https://drive.google.com/file/d/1XKc9znd4sXcEgC5fEYJcFhNuOhHElmBw/view?usp=drivesdk",
  },


  {
    date: "2025-10-10",
    startDate: "10.10.2025",
    endDate: "",
    title: "Ignite-25 (EDC)",
    type: "",
    coordinator: "Dr.D.Helena Margaret (ASP) ECE Dept ",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/ignite1.webp`,
      `${cdn}/iqac/ignite2.webp`,
      `${cdn}/iqac/ignite3.webp`,
      `${cdn}/iqac/ignite4.webp`
    ],
    pdf: "",
  },


  {
    date: "2025-10-09",
    startDate: "09.10.2025",
    endDate: "",
    title: "AURA-25(Music Club)",
    type: "",
    coordinator: "Dr.Balasundar (ASP) Maths Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Aura+Installation.webp`,
      `${cdn}/iqac/Aura+Installation1.webp`,
      `${cdn}/iqac/Aura+Installation2.webp`,
      `${cdn}/iqac/Aura+Installation3.webp`
    ],
    pdf: "",
  },

  {
    date: "2025-10-08",
    startDate: "08.10.2025",
    endDate: "",
    title: "Motivational Seminar by Leena Thomas (Dept ECE )",
    type: "",
    coordinator: "Miss.P.Sezhina Kanakambika (ASP) ECE Dept ",
    venue: "COE Lab( Dept ECE)",
    photos: [
      `${cdn}/iqac/Motivational+seminar1.webp`,
      `${cdn}/iqac/Motivational+seminar.webp`,
      `${cdn}/iqac/Motivational+seminar+3.webp`,
      `${cdn}/iqac/Motivational+Seminar2.webp`

    ],
    pdf: "",
  },

  {
    date: "2025-10-08",
    startDate: "08.10.2025",
    endDate: "",
    title: " Grand Opening of Smart EV Charging Point (Dept EEE) ",
    type: "",
    coordinator: "Dept EEE",
    venue: "ACGCET Main Gate Entrance",
    photos: [
      `${cdn}/iqac/Smart+EV+Charging+Point3.webp`,
      `${cdn}/iqac/Smart+EV+Charging+Point2.webp`,
      `${cdn}/iqac/Smart+EV+Charging+Point1.webp`,
      `${cdn}/iqac/Smart+EV+Charging+Point.webp`
    ],
    pdf: "",
  },

  {
    date: "2025-10-06",
    startDate: "06.10.2025",
    endDate: "15.10.2025",
    title: " Training Programme on Mechanical Design Software by TVS ",
    type: "",
    coordinator: "Dr.X.Hyacinth Suganthi Placement Coordinator",
    venue: "Saaral Placement Centre",
    photos: [
      `${cdn}/iqac/mechanical+software+intern25.webp`,
      `${cdn}/iqac/Mechanical+Design+Software+Intern3.webp`,
      `${cdn}/iqac/Mechanical+Design+Software+Intern1.webp`,
      `${cdn}/iqac/Mechanical+Design+Software+Intern2.webp`


    ],
    pdf: "",
  },
  {
    date: "2025-09-30",
    startDate: "30.09.2025",
    endDate: "",
    title: "Aayudha Pooja Celebraction",
    type: "",
    coordinator: "ACGCET",
    venue: "ACGCET",
    photos: [
      `${cdn}/iqac/AYUDHA+POOJA+1.webp`,
      `${cdn}/iqac/AYUDHA+POOJA+2.webp`,
      `${cdn}/iqac/AYUDHA+POOJA+3.webp`,
      `${cdn}/iqac/AYUDHA+POOJA+4.webp`
    ],
    pdf: ""

  },
  {
    date: "2025-09-29",
    startDate: "29.09.2025",
    endDate: "",
    title: "Clickz-25 (Media Club)",
    type: "",
    coordinator: "Dr.A.Sivanantha Raja (HOD) ECE Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/clickz+1.webp`,
      `${cdn}/iqac/clickz+2.webp`,
      `${cdn}/iqac/clickz+3.webp`,
      `${cdn}/iqac/clickz+4.webp`
    ],
    pdf: ""
  },
  {
    date: "2025-09-29",
    startDate: "29.09.2025",
    endDate: "",
    title: "World Heart Day–Cardiology Screening Camp organized by Lions Club & ACGCET",
    type: "",
    coordinator: "Mr.S.Aasaimani (AP) EEE Dept",
    venue: "EEE Dept New Building",
    photos: [
      `${cdn}/iqac/WORLD+HEART+DAY+1.webp`,
      `${cdn}/iqac/WORLD+HEART+DAY+2.webp`,
      `${cdn}/iqac/WORLD+HEART+DAY+3.webp`,
      `${cdn}/iqac/WORLD+HEART+DAY+4.webp`
    ],
    pdf: ""
  },
  {
    date: "2025-09-25",
    startDate: "25.09.25",
    endDate: "",
    title: "கல்வியில் சிறந்த தமிழ்நாடு (online)",
    type: "",
    coordinator: "TN Programme",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/%E0%AE%95%E0%AE%B2%E0%AF%8D%E0%AE%B5%E0%AE%BF%E0%AE%AF%E0%AE%BF%E0%AE%B2%E0%AF%8D+%E0%AE%9A%E0%AE%BF%E0%AE%B1%E0%AE%A8%E0%AF%8D%E0%AE%A4+%E0%AE%A4%E0%AE%AE%E0%AE%BF%E0%AE%B4%E0%AF%8D%E0%AE%A8%E0%AE%BE%E0%AE%9F%E0%AF%81+1.webp`,
      `${cdn}/iqac/%E0%AE%95%E0%AE%B2%E0%AF%8D%E0%AE%B5%E0%AE%BF%E0%AE%AF%E0%AE%BF%E0%AE%B2%E0%AF%8D+%E0%AE%9A%E0%AE%BF%E0%AE%B1%E0%AE%A8%E0%AF%8D%E0%AE%A4+%E0%AE%A4%E0%AE%AE%E0%AE%BF%E0%AE%B4%E0%AF%8D%E0%AE%A8%E0%AE%BE%E0%AE%9F%E0%AF%81+2.webp`,
      `${cdn}/iqac/%E0%AE%95%E0%AE%B2%E0%AF%8D%E0%AE%B5%E0%AE%BF%E0%AE%AF%E0%AE%BF%E0%AE%B2%E0%AF%8D+%E0%AE%9A%E0%AE%BF%E0%AE%B1%E0%AE%A8%E0%AF%8D%E0%AE%A4+%E0%AE%A4%E0%AE%AE%E0%AE%BF%E0%AE%B4%E0%AF%8D%E0%AE%A8%E0%AE%BE%E0%AE%9F%E0%AF%81+3.webp`,
      `${cdn}/iqac/%E0%AE%95%E0%AE%B2%E0%AF%8D%E0%AE%B5%E0%AE%BF%E0%AE%AF%E0%AE%BF%E0%AE%B2%E0%AF%8D+%E0%AE%9A%E0%AE%BF%E0%AE%B1%E0%AE%A8%E0%AF%8D%E0%AE%A4+%E0%AE%A4%E0%AE%AE%E0%AE%BF%E0%AE%B4%E0%AF%8D%E0%AE%A8%E0%AE%BE%E0%AE%9F%E0%AF%81+4.webp`

    ],
    pdf: ""
  },
  {
    date: "2025-09-25",
    startDate: "25.09.2025",
    endDate: "",
    title: " Living in Space(World Space Week)-organized by IIC & IQAC",
    type: "",
    coordinator: "Dr.S.R.Cynthia (ASP) Physics Dept & IIC",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/LIVING+IN+SPACE+1.webp`,
      `${cdn}/iqac/LIVING+IN+SPACE+2.webp`,
      `${cdn}/iqac/LIVING+IN+SPACE+3.webp`,
      `${cdn}/iqac/LIVING+IN+SPACE+4.webp`
    ],
    pdf: ""
  },
  {
    date: "2025-09-25",
    startDate: "25.09.2025",
    endDate: "",
    title: "GATE-JAM 2026 Awareness Programme",
    type: "",
    coordinator: "Dr.S.M.Sivagami (ASP) MECH Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/GATE+JAM+1.webp`,
      `${cdn}/iqac/GATE+JAM+2.webp`,
      `${cdn}/iqac/GATE+JAM+3.webp`,
      `${cdn}/iqac/GATE+JAM+4.webp`
    ],
    pdf: ""

  },


  {
    date: "2025-09-20",
    startDate: "20.09.2025",
    endDate: "",
    title: "Fresher's Induction program (ISTE) CSE Dept",
    type: "",
    coordinator: "Dr.C.Uma Rani (HOD) CSE Dept",
    venue: "Murugappa Hall",
    photos: [`${cdn}/iqac/ISTE1.webp`,
    `${cdn}/iqac/ISTE+2.webp`,
    `${cdn}/iqac/ISTE+3.webp`,
    `${cdn}/iqac/ISTE+4.webp`
    ],
    pdf: "https://drive.google.com/file/d/17ji4Jg6v0jcmVq9PFY5X-wBnv-NXX6cv/view"
  },
  {
    date: "2025-09-19",
    startDate: "19.09.2025",
    endDate: "",
    title: "POCSO Awareness Program Organized by Sustainable Development Goals club",
    type: "",
    coordinator: "Dr.S.Geetha (ASP) MECH Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/ACGCET+Faculty+and+Students.webp`,
      `${cdn}/iqac/sexual+Harassment+prevention+committee+(ACGCET).webp`,
      `${cdn}/iqac/Speech+on+POCSO+Act.webp`,
      `${cdn}/iqac/physics+Dept.jpeg`
    ],
    pdf: ""
  },
  {
    date: "2025-09-18",
    startDate: "18.09.2025",
    endDate: "",
    title: " ZYRA-25  Fresher's Party(ECE) ",
    type: "",
    coordinator: "Mrs.M.Aruna Rani (AP) ECE  Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Zyra+freshers+party+1.webp`,
      `${cdn}/iqac/Zyra+freshers+party+2.webp`,
      `${cdn}/iqac/Zyra+freshers+party+3.webp`,
      `${cdn}/iqac/Zyra+freshers+party+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-09-18",
    startDate: "18.09.2025",
    endDate: "",
    title: "Palm Seed Planting-ECE Dept",
    type: "",
    coordinator: "Dr.A.Sivanantha Raja (HOD) ECE Dept",
    venue: "COE Office Back Side",
    photos: [
      `${cdn}/iqac/palm+seed+planting+1.webp`,
      `${cdn}/iqac/palm+seed+planting+2.webp`,
      `${cdn}/iqac/palm+seed+planting+3.webp`,
      `${cdn}/iqac/palm+seed+planting+4.webp`

    ],
    pdf: "",
  },
  {
    date: "2025-09-17",
    startDate: "17.09.2025",
    endDate: "",
    title: "Leo Club Inauguration-25",
    type: "",
    coordinator: "Mr.V.Jawahar (AP) MECH Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Leo+Club+Inauguration+1.webp`,
      `${cdn}/iqac/Leo+Club+Inauguration+2.webp`,
      `${cdn}/iqac/Leo+Club+Inauguration+3.webp`,
      `${cdn}/iqac/Leo+Club+Inauguration+4.webp`

    ],
    pdf: "https://drive.google.com/file/d/1XMbtGQRBz1rdQl0v7OzeumK1guFOe4X4/view?usp=drivesdk",
  },
  {
    date: "2025-09-16",
    startDate: "16.09.2025",
    endDate: "",
    title: "Tree Planting Ceremony of ACGCET Faculty - Organized by NSS",
    type: "",
    coordinator: "NSS Programme",
    venue: "ACGCET CAMPUS",
    photos: [
      `${cdn}/iqac/Tree+planting+1.webp`,
      `${cdn}/iqac/Tree+planting+2.webp`,
      `${cdn}/iqac/Tree+planting+3.webp`,
      `${cdn}/iqac/Tree+planting+4.webp`

    ],
    pdf: "",
  },
  {
    date: "2025-09-12",
    startDate: "12.09.2025",
    endDate: "",
    title: "Outcome Base Education (DOTE)-one Training Programme online ",
    type: "",
    coordinator: "TN Programme",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/outcome+base+education+1.webp`,
      `${cdn}/iqac/outcome+base+education+2.webp`,
      `${cdn}/iqac/outcome+base+education++3.webp`,
      `${cdn}/iqac/outcome+base+education+4.webp`

    ],
    pdf: "",
  },
  {
    date: "2025-09-10",
    startDate: "10.09.2025",
    endDate: "",
    title: "Thiran Kickoff'-2025 For First Years",
    type: "",
    coordinator: "ACCETOSA",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/thiran+kickoff+1.webp`,
      `${cdn}/iqac/Thiran+kickoff+2.webp`,
      `${cdn}/iqac/Thiran+Kickoff+3.webp`,
      `${cdn}/iqac/thiran+kickoff+4.webp`
    ],
    pdf: "https://drive.google.com/file/d/1Ere-HiVoq8eSh-JlPKM-hqp0cpSGCNMp/view?usp=sharing",
  },
  {
    date: "2025-09-09",
    startDate: "09.09.2025",
    endDate: "",
    title: "Fresher's Day-2025",
    type: "",
    coordinator: "Dr.S.R.Cynthia (AP) Physics Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Freshers+day+1+(1).webp`,
      `${cdn}/iqac/freshers+day+2.webp`,
      `${cdn}/iqac/freshers+day+3+(1).webp`,
      `${cdn}/iqac/freshers+day+4.webp`
    ],
    pdf: "https://drive.google.com/file/d/1xpsAP_V0-GrY2VFss6Z02EMuWz_FeY2V/view",
  },
  {
    date: "2025-09-08",
    startDate: "08.09.2025",
    endDate: "",
    title: "Higher Education Guidance for Government School Students-2025",
    type: "",
    coordinator: "TN Programme",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/students+education+1.webp`,
      `${cdn}/iqac/student+education+2.webp`,
      `${cdn}/iqac/student+education+3.webp`,
      `${cdn}/iqac/student+education+4.webp`


    ],
    pdf: "",
  },
  {
    date: "2025-09-05",
    startDate: "05.09.2025",
    endDate: "",
    title: "Teacher's Day Celebration-2025(Rotaract club)",
    type: "",
    coordinator: "Mr.V.Pradeep (AP) EEE Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/Teacher_s-Day-1.webp`,
      `${cdn}/iqac/Teacher_s-Day-2.webp`,
      `${cdn}/iqac/Teacher_s-Day-3-.webp`,
      `${cdn}/iqac/Teacher_s-Day-4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-28",
    startDate: "28.08.2025",
    endDate: "",
    title: "Pitch Perfect - EDC PROGRAM",
    type: "",
    coordinator: "Dr.D.Helena Margaret (ASP) ECE Dept ",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/pitchdesk2.webp`,
      `${cdn}/iqac/pitchdesk1.webp`,
      `${cdn}/iqac/pitchdesk3.webp`,
      `${cdn}/iqac/pitchdesk4.webp`


    ],
    pdf: "https://drive.google.com/file/d/14bGHQoHVHJRf1d3hYEYgYDUgiblzk433/view",
  },






  {
    date: "2025-08-26",
    startDate: "26.08.2025",
    endDate: "",
    title: "Workshop On IPR (IIC) ECE Dept",
    type: "",
    coordinator: "Dr.G.Karpagarajesh (AP) ECE Dept",
    venue: "COE Lab(ECE Dept)",
    photos: [
      `${cdn}/iqac/workshop+ipr+1.webp`,
      `${cdn}/iqac/workshop+ipr+2.webp`,
      `${cdn}/iqac/workshop+ipr+3.webp`,
      `${cdn}/iqac/workshop+ipr+4.webp`
    ],
    pdf: "",
  },

  {
    date: "2025-08-25",
    startDate: "25.08.2025",
    endDate: "",
    title: "Autonomous Exam Hall Inauguration",
    type: "",
    coordinator: "ACGCET",
    venue: "COE Back Side",
    photos: [
      `${cdn}/iqac/autonomous+inaguration+1.webp`,
      `${cdn}/iqac/autonomous+inaguration+2.webp`,
      `${cdn}/iqac/autonomous+inaguration+3.webp`,
      `${cdn}/iqac/autonomous+inaguration+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-15",
    startDate: "15.08.2025",
    endDate: "",
    title: "Independence Day Celebration",
    type: "",
    coordinator: "ACGCET",
    venue: "Main Building ",
    photos: [
      `${cdn}/iqac/independence+day+1.webp`,
      `${cdn}/iqac/indepence+day+2.webp`,
      `${cdn}/iqac/independence+day+3.webp`,
      `${cdn}/iqac/independence+day+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-11 ",
    startDate: "11.08.2025",
    endDate: "19.08.2025",
    title: "Induction Programme -2025",
    type: "",
    coordinator: "Dr.S.Ponmudi (HOD) Physics Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/induction+program+1.webp`,
      `${cdn}/iqac/induction+program+2.webp`,
      `${cdn}/iqac/induction+program+3.webp`,
      `${cdn}/iqac/induction+program+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-11",
    startDate: "11.08.2025",
    endDate: "",
    title: "Drug Free Tamil Nadu",
    type: "TN Program",
    coordinator: "",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/drug+free+1.webp`,
      `${cdn}/iqac/drug+2.webp`,
      `${cdn}/iqac/drug+free+3.webp`,
      `${cdn}/iqac/drug+free+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-07",
    startDate: "07.08.2025",
    endDate: "",
    title: "Grand Opening of the WiFi TREE ",
    type: "Leo Club",
    coordinator: "  Mr.V.Jawahar (AP) MECH Dept",
    venue: "Murugappa Hall (opp)",
    photos: [
      `${cdn}/iqac/wifi_tree_rewamp1.webp`,
      `${cdn}/iqac/wifi_tree_rewamp2.webp`,
      `${cdn}/iqac/wifi_tree_rewamp3.webp`,
      `${cdn}/iqac/wifi_tree_rewamp4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-06",
    startDate: "6.08.2025",
    endDate: "",
    title: "Anti-drug Awareness Rally",
    type: "",
    coordinator: "Mr.S.Balasundar (AP) Maths Dept",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/anti+drug+1.webp`,
      `${cdn}/iqac/anti+drug+2.webp`,
      `${cdn}/iqac/anti+drug+3.webp`,
      `${cdn}/iqac/anti+drug+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-08-05",
    startDate: "05.08.2025",
    endDate: "",
    title: "ThinkLike a Founder",
    type: "EDII Program",
    coordinator: "Dr.D.Helena Margaret (AP) ECE Dept",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/edii+1.webp`,
      `${cdn}/iqac/edii+2.webp`,
      `${cdn}/iqac/edii+3.webp`,
      `${cdn}/iqac/edii+4.webp`
    ],
    pdf: "",
  },

  {
    date: "2025-07-30",
    startDate: "30.07.2025",
    endDate: "",
    title: "Clone To Learn-8 Hours Hackathon",
    type: "",
    coordinator: "ACCETOSA",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/clone1.webp`,
      `${cdn}/iqac/clone+2.webp`,
      `${cdn}/iqac/clone+3.webp`,
      `${cdn}/iqac/clone+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-07-28",
    startDate: "28.07.2025",
    endDate: "02.08.2025",
    title: "NM-FDP on Employability Skills & Pro-E",
    type: "CreoDesign",
    coordinator: "TN Program",
    venue: "EEE-Virtual Hall & MECH Dept",
    photos: [
      `${cdn}/iqac/nm1.webp`,
      `${cdn}/iqac/nm2.webp`,
      `${cdn}/iqac/nm3.webp`,
      `${cdn}/iqac/nm4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-07-28",
    startDate: "28.07.2025",
    endDate: "",
    title: "Seminar for MECH  Students presented by Alumni(1996 to 2000 )batch",
    type: "",
    coordinator: "Mr.S.Senthilkumar (AP) MECH Dept",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/mech+seminar+1.webp`,
      `${cdn}/iqac/mech+seminar+2.webp`,
      `${cdn}/iqac/mech+seminar+3.webp`,
      `${cdn}/iqac/mech+seminar+4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-07-28",
    startDate: "28.07.2025",
    endDate: "",
    title: "ISTE-RESUME BUILDING WORKSHOP",
    type: "",
    coordinator: "ACGCET",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/iste+resume+1.webp`,
      `${cdn}/iqac/iste+resume+2.webp`,
      `${cdn}/iqac/iste+resume+3.webp`,
      `${cdn}/iqac/iste+resume+4.webp`
    ],
    pdf: "https://drive.google.com/file/d/1XCq-u9j31dSaSzZlv8_pnFSrJCrKLqSK/view",
  },

  {
    date: "2025-07-24",
    startDate: "24.07.2025",
    endDate: "",
    title: "Faculty conducts tree plantation",
    type: "",
    coordinator: "Faculty of ACGCET 2006 Batch",
    venue: "MECH Dept Back Side",
    photos: [
      `${cdn}/iqac/tree+plantation+1.webp`,
      `${cdn}/iqac/tree+plantation+2.webp`,
      `${cdn}/iqac/tree+plantation+3.webp`,
      `${cdn}/iqac/tree+plantation+4.webp`
    ],
    pdf: "",
  },

  {
    date: "2025-07-24",
    startDate: "24.07.2025",
    endDate: "",
    title: "Leo Club Students Installs College MAP banner",
    type: "",
    coordinator: "Mr.V.Jawahar (AP) MECH Dept",
    venue: "GATE (ACGCET)",
    photos: [
      `${cdn}/iqac/leo_map1.webp`,
      `${cdn}/iqac/leo_map2.webp`,
      `${cdn}/iqac/leo_map3.webp`
    ],

  },
  {
    date: "2025-07-21",
    startDate: "21.07.2025",
    endDate: "",
    title: "ECE Association Inauguration",
    type: "",
    coordinator: "Mrs.M.Aruna Rani (AP) ECE  Dept",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/Ece_asso_1.webp`,
      `${cdn}/iqac/Ece_asso_2.webp`,
      `${cdn}/iqac/Ece_asso_3.webp`,
      `${cdn}/iqac/ece_asso4.webp`
    ],

  },
  {
    date: "2025-07-17",
    startDate: "17.07.2025",
    endDate: "",
    title: "Innovation and Startup Ecosystem  - Faculty",
    type: "",
    coordinator: "Dr.S.M.Kavitha (ASP) CIVIL Dept",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/Startup_ecosystem_Faculty_1.webp`,
      `${cdn}/iqac/Startup_ecosystem_Faculty_2.webp`,
      `${cdn}/iqac/Startup_ecosystem_Faculty_3.webp `,
      `${cdn}/iqac/Startup_ecosystem_Faculty_4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-07-17",
    startDate: "17.07.2025",
    endDate: "",
    title: "Innovation and Startup Ecosystem - Student",
    type: "",
    coordinator: "Dr.S.M.Kavitha (ASP) CIVIL Dept ",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/Startup_ecosystem_1.webp`,
      `${cdn}/iqac/Startup_ecosystem_2.webp`,
      `${cdn}/iqac/Startup_ecosystem_3.webp`,
      `${cdn}/iqac/Startup_ecosystem_4.webp`
    ],
    pdf: "",
  },
  {
    date: "2025-07-15",
    startDate: "15.07.2025",
    endDate: "16.07.2025",
    title: "Two day Induction programme ",
    type: "For 2nd & 3rd Year Students",
    coordinator: "Mr.S. SenthilKumar (AP) MECH Dept & Dr.X.Hyacinth Suganthi (Placement Coordinator )",
    venue: "Murugappa Hall",
    photos: [
      `${cdn}/iqac/2day_induction_1.webp`,
      `${cdn}/iqac/2day_induction_2.webp`,
      `${cdn}/iqac/2day_induction_3.webp`,
      `${cdn}/iqac/2day_induction_4.webp`
    ],

  },
  {
    date: "2025-07-11",
    startDate: "11.07.2025 ",
    endDate: "12.07.2025",
    title: "ACCETOSA & Thiran Workshop (ECE)",
    type: "Effective public speaking skills ",
    coordinator: "Mr.S. Senthilkumar (AP) MECH Dept",
    venue: "Optical Lab(ECE)",
    photos: [
      `${cdn}/iqac/public_speaking_1.webp`,
      `${cdn}/iqac/public_speaking_2.webp`,
      `${cdn}/iqac/public_speaking_3.webp`,
      `${cdn}/iqac/public_speaking_4.webp`,

    ],
    pdf: "https://drive.google.com/file/d/1XNf0BteEJQA58eCtCRDaVukAaVh75Khi/view?usp=drivesdk",
  },
  {
    date: "2025-07-07",
    startDate: "07.07.2025",
    endDate: "",
    title: "ACGCET MCA -1992-1995 Batch Alumni Meet ",
    type: "30 years Reunion",
    coordinator: "Mr.S. Senthilkumar (AP) MECH Dept",
    venue: "Sangamam Hall",
    photos: [
      `${cdn}/iqac/accet_MCA_1.webp`,
      `${cdn}/iqac/accet_MCA_2.webp`,
      `${cdn}/iqac/accet_MCA_3.webp`,
      `${cdn}/iqac/Accet_MCA_4.webp`,

    ],

  },
  {
    date: "2025-06-17",
    startDate: "17.06.2025",
    endDate: "23.06.2025",
    title: "Mudhalvarin  Kaakkum Karangal (MKKS) ",
    type: "EDII Program",
    coordinator: "TN Program",
    venue: "EEE Conference Hall",
    photos: [
      `${cdn}/iqac/muthalvarimg.webp`,
      `${cdn}/iqac/Mr.K.Sankaralingam-Greenscrat+Madurai++++++Business+Plan+Project+%2CMarket+Survey.webp`,
      `${cdn}/iqac/ArumaiRooban+EDII+Distric+Manager+Sivaganigai+(1).webp`,
      `${cdn}/iqac/Capt.VijayakumarAssitant+DirectorExserviceman+WelfareOffice%2CSivagangai..webp`,

    ],
    pdf: "https://drive.google.com/file/d/1h0cXnRWGK-XX1RsDv-AEeKf5HPEXLetO/view",
  },
  {
    date: "2025-06-02",
    startDate: "02.06.2025",
    endDate: "13.06.2025",
    title: "Fundamentals of Electronic Testing (ECE Dept)",
    type: "Skill Development / Internship Programme",
    coordinator: "Dr.S.Somasundaram (ASP) ECE Dept",
    venue: "COE Lab (ECE Dept)",
    photos: [
      `${cdn}/iqac/ACGCETPRINCIPAL.webp`,
      `${cdn}/iqac/ECE+HOD.webp`,
      `${cdn}/iqac/Electronic+test.webp`,
      `${cdn}/iqac/QMAX+Test+equipment's+Trainee.webp`,

    ],

  },

];

export default programmes;